// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M11.9968 1.6582L22.4127 10.9168L21.084 12.4116L20.0009 11.4489V21.9998H15.5V15H8.5V21.9998H4.00092V11.4536L2.90685 12.4109L1.58984 10.9058L6.00092 7.04607V2.99984H8.00092V5.25448L11.9968 1.6582Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.5 22V17H13.5V22H10.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-houses-filled')
export default class HousesFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'houses-filled',
    }
  }
}
